import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Vehicle, VehicleKind } from '@/new-transport/_models/transport.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Result } from '@/reservation/reservation.model';

@Injectable({
	providedIn: 'root',
})
export class VehiclesSidenavApiService {
	private readonly httpClient = inject(HttpClient);
	private readonly apiUrl = environment.apiUrl;

	getRealVehiclesByName(filterValue = ''): Observable<Result<Vehicle>> {
		return this.httpClient.get<Result<Vehicle>>(
			`${this.apiUrl}/transport/vehicle/?name=${filterValue}&vehicle_kind=${VehicleKind.REAL}&limit=999`,
		);
	}

	getVirtualVehiclesByName(filterValue = ''): Observable<Result<Vehicle>> {
		return this.httpClient.get<Result<Vehicle>>(
			`${this.apiUrl}/transport/vehicle/?name=${filterValue}&vehicle_kind=${VehicleKind.VIRTUAL}&limit=999`,
		);
	}

	getPlanes(): Observable<Result<Vehicle>> {
		return this.httpClient.get<Result<Vehicle>>(
			`${this.apiUrl}/transport/vehicle/?vehicle_kind=${VehicleKind.PLANE}&limit=999`,
		);
	}
}
